import { render, staticRenderFns } from "./projectCase.vue?vue&type=template&id=b157b39c&scoped=true"
import script from "./projectCase.vue?vue&type=script&lang=js"
export * from "./projectCase.vue?vue&type=script&lang=js"
import style0 from "./projectCase.vue?vue&type=style&index=0&id=b157b39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b157b39c",
  null
  
)

export default component.exports